<script setup>
import { computed } from 'vue'
import { Table } from '@drama/ui'

import AuditCard from './AuditCard.vue'
import { useAuditText } from './audit-text.js'
import { characterName, currentItems, placeName } from './run-observer.js'

const props = defineProps({
  pack: { type: Object, required: true },
  branch: { type: Object, required: true },
})

const { tr } = useAuditText()
const items = computed(() => currentItems(props.pack, props.branch.state))
const columns = computed(() => [
  { key: 'name', label: tr('timeline.item'), width: '170px', wrap: true },
  { key: 'holder', label: tr('timeline.holder'), width: '120px' },
  { key: 'place', label: tr('timeline.place'), width: '140px' },
])
</script>

<template>
  <AuditCard :title="tr('timeline.items')">
    <template #meta>{{ items.length }}</template>
    <Table v-if="items.length" :columns="columns" :rows="items" row-key="id">
      <template #name="{ row }">
        <img v-if="row.image" class="au-thumb" :src="row.image" :alt="row.name" />
        <span :title="row.description || row.name">{{ row.name }}</span>
      </template>
      <template #holder="{ row }">{{ row.holder_id ? characterName(pack, row.holder_id) : tr('timeline.unheld') }}</template>
      <template #place="{ row }">{{ placeName(pack, row.location_id) }}</template>
    </Table>
    <p v-else class="au-empty">{{ tr('empty') }}</p>
  </AuditCard>
</template>
